import { Injectable, inject } from '@angular/core';
import { GapiClientLoaderGeneratorService } from './gapi-client-loader-generator.service';

@Injectable({
  providedIn: 'root',
})
export class DedupingGeneratorService {
  private gapiClientLoaderGeneratorService = inject(
    GapiClientLoaderGeneratorService,
  );

  generate(libName: string, libVer: string, baseUrl?: string) {
    let generator: Promise<any>;

    return () => {
      if (generator) {
        return generator;
      }

      generator = this.gapiClientLoaderGeneratorService
        .generate(libName, libVer, baseUrl)()
        .finally(() => {
          generator = undefined;
        });

      return generator;
    };
  }
}
